import { render, staticRenderFns } from "./FormLatitud.vue?vue&type=template&id=6be251fa&scoped=true"
import script from "./FormLatitud.vue?vue&type=script&lang=js"
export * from "./FormLatitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be251fa",
  null
  
)

export default component.exports